/*global window */
'use strict';
var CareAssessmentService = window.kerpCfa.common.CareAssessmentService;

CareAssessmentService.$inject = ['numberUtils', 'configuration'];

angular.module('kerp-forms.forms').service('careAssessmentService', CareAssessmentService);
